import React from "react";

export default function ItemLogo({
  firstName,
  lastName,
  avatar,
  sessionRoomLink,
}) {
  const openChat = () => {
    if (sessionRoomLink != "") {
      window.open(sessionRoomLink, "_blank").focus();
    }
  };

  return (
    <div className="coach-name">
      <img
        onClick={openChat}
        className={`img-circle ${
          sessionRoomLink == "" ? "" : "cursor-pointer"
        } mr10`}
        alt="avatar"
        width="35px"
        src={avatar}
      />
      <div
        onClick={openChat}
        className={`text ${
          sessionRoomLink == "" ? "" : "cursor-pointer"
        } coach mt5`}
      >
        {firstName}
        <br />
        {lastName}
      </div>
    </div>
  );
}
